import { render, staticRenderFns } from "./SimpleDTrev.vue?vue&type=template&id=f9c6935c&"
import script from "./SimpleDTrev.vue?vue&type=script&lang=js&"
export * from "./SimpleDTrev.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDTrev.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports